export const videoUrlsRegex = new RegExp(
  [
    '^https:\\/\\/(?:www\\.',
    '(youtube|youtube-nocookie)\\.com\\/embed\\/\\S+',
    '|(?:player\\.vimeo\\.com\\/video\\/\\S+)',
    '|(?:vimeo\\.com*\\S+)',
    '|(?:player\\.twitch\\.tv\\/\\S+)',
    '|(?:www\\.twitch\\.tv\\/videos\\/\\S+)',
    '|(?:www\\.dailymotion.com\\/embed\\/video\\/\\S+)',
    '|(?:open.spotify.com\\/embed\\/\\S+)',
    ')$',
  ].join(''),
  'i',
);
